import React from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  return (
    <div className="Header">
      <div className="header-buttons-container">
        <button
          onClick={() => navigate("/education")}
          className="header-button"
        >
          Education
        </button>
        <button
          onClick={() => navigate("/experience")}
          className="header-button"
        >
          Experience
        </button>
        <button onClick={() => navigate("/projects")} className="header-button">
          Projects
        </button>
      </div>
    </div>
  );
}

export default Header;
